import React, { useMemo, useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { VCardModalWrapper } from './VCardModalWrapper';

interface VCardDisplayProps {
    vCardString: string;
}

export const VCardDisplay = ({ vCardString }: VCardDisplayProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    console.log("VCardDisplay", vCardString)
    const { name, phone } = useMemo(() => {
        if (!vCardString) {
            return { name: '', phone: '' };
        }

        const decodedString = decodeURIComponent(vCardString);
        const lines = decodedString.split('\n');

        let vCardName = '';
        let vCardPhone = '';

        lines.forEach(line => {
            const trimmedLine = line.trim();

            if (trimmedLine.startsWith('FN:')) {
                vCardName = trimmedLine.substring(3);
            }

            else if (trimmedLine.includes('TEL')) {
                const parts = trimmedLine.split(':');
                if (parts.length > 1) {
                    vCardPhone = parts[1];
                }
            }
        });

        return { name: vCardName, phone: vCardPhone };
    }, [vCardString]);


    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    padding: '12px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    maxWidth: '350px',
                    cursor: 'pointer'
                }}
                onClick={() => setIsModalOpen(true)}
            >
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: '#bdbdbd',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff'
                }}>
                    <FaUser style={{ fontSize: '32px' }} />
                </div>
                <div style={{ fontWeight: 'bold', flexGrow: 1 }}>
                    {name}
                    <div style={{ fontSize: '12px', opacity: 0.7 }}>
                        {phone}
                    </div>
                </div>
            </div>

            <VCardModalWrapper
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                contactName={name}
                contactPhone={phone}
            />
        </>
    );
};